import { useListInvoices } from '@/api/accounting-dealer'
import { Invoice } from '@/types'
import { ErrorOutline } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Typography, Stack, Box, Skeleton } from '@mui/material'
import { useState, useEffect, useRef } from 'react'
import { InvoiceCard } from './invoice-card'

type InvoicesListProps = {
  dealKey: string
}

export function InvoicesList({ dealKey }: InvoicesListProps) {
  const [page, setPage] = useState(1)
  const [invoices, setInvoices] = useState<Invoice[]>([])

  const count = useRef(0)

  const {
    data: invoicesData,
    isLoading: readingInvoices,
    isError,
  } = useListInvoices({
    deal_key: dealKey,
    page,
    page_size: 5,
  })

  useEffect(() => {
    if (!invoicesData) return

    count.current = invoicesData.count

    setInvoices((state) => [...state, ...invoicesData.data])
  }, [invoicesData])

  if (readingInvoices && page === 1) {
    return <LoadingSkeleton />
  }

  if (isError) {
    return <ErrorMessage />
  }

  if (invoices.length === 0) {
    return (
      <Typography color="gray" textAlign="center">
        Nenhum boleto encontrado.
      </Typography>
    )
  }

  const hasMore = count.current > invoices.length

  return (
    <Stack gap={[1, 2]} p="1px" pb={10}>
      {invoices.map((invoice) => (
        <InvoiceCard key={invoice.id} {...invoice} />
      ))}

      {hasMore && (
        <LoadingButton
          variant="outlined"
          loading={readingInvoices}
          onClick={() => setPage((state) => state + 1)}
          sx={{ mt: 2, alignSelf: 'center' }}
        >
          Carregar mais
        </LoadingButton>
      )}
    </Stack>
  )
}

const LoadingSkeleton = () => (
  <Stack spacing={1}>
    {Array.from(new Array(5)).map((_, i) => (
      <Skeleton key={i} variant="rounded" height={50} />
    ))}
  </Stack>
)

const ErrorMessage = () => (
  <Box textAlign="center">
    <ErrorOutline color="error" fontSize="large" />
    <Typography color="gray">Não foi possível carregar os boletos.</Typography>
  </Box>
)
